export const columnHeader = [
  {
    key: "link",
    name: "link",
    type: "text",
    system: false,
    filter: true,
  },
  {
    key: "name",
    name: "Name",
    type: "text",
    system: false,
    filter: true,
  },
  {
    key: "price",
    name: "Price",
    type: "number",
    system: false,
    filter: true,
  },
  {
    key: "bandwidth",
    name: "Bandwidth ",
    type: "text",
    system: false,
    filter: true,
  },

  {
    key: "dedicated_account_manager",
    name: "Dedicated Account Manager",
    type: "text",
    system: false,
    filter: true,
  },

  {
    key: "over_100_countries",
    name: "Over 100 Countries",
    type: "text",
    system: false,
    filter: true,
  },

  {
    key: "residential_static",
    name: "Residential Static",
    type: "text",
    system: false,
    filter: true,
  },

  {
    key: "residential_rotating",
    name: "Residential Rotating",
    type: "text",
    system: false,
    filter: true,
  },
  {
    key: "locations",
    name: "Locations",
    type: "text",
    system: false,
    filter: true,
  },
  {
    key: "username",
    name: "Username",
    type: "text",
    system: false,
    filter: true,
  },
  {
    key: "password",
    name: "Password",
    type: "text",
    system: false,
    filter: true,
  },
  {
    key: "actions",
    name: "",
    type: "actions",
    system: true,
    filter: false,
  },
];

export const yeNo = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
